// action types
import { createRequestTypes } from "../../utils";

// Fetch user's orders (authenticated)
export const FETCH_USER_ORDERS = createRequestTypes("FETCH_USER_ORDERS");

// Fetch single order detail
export const FETCH_ORDER_DETAIL = createRequestTypes("FETCH_ORDER_DETAIL");

// Track order publicly (by email + order_id)
export const TRACK_ORDER = createRequestTypes("TRACK_ORDER");

// Clear tracking state
export const CLEAR_TRACKING = "CLEAR_TRACKING";


// FETCH USER ORDERS (authenticated users)
export const fetchUserOrdersRequest = (page = 1) =>
  ({ type: FETCH_USER_ORDERS.REQUEST, payload: { page } });

export const fetchUserOrdersSuccess = (payload) =>
  ({ type: FETCH_USER_ORDERS.SUCCESS, payload });

export const fetchUserOrdersFailure = (error) =>
  ({ type: FETCH_USER_ORDERS.FAILURE, payload: { error } });


// FETCH ORDER DETAIL
export const fetchOrderDetailRequest = (orderId) =>
  ({ type: FETCH_ORDER_DETAIL.REQUEST, payload: { orderId } });

export const fetchOrderDetailSuccess = (payload) =>
  ({ type: FETCH_ORDER_DETAIL.SUCCESS, payload });

export const fetchOrderDetailFailure = (error) =>
  ({ type: FETCH_ORDER_DETAIL.FAILURE, payload: { error } });


// TRACK ORDER (public - by email + order_id)
export const trackOrderRequest = (email, orderId) =>
  ({ type: TRACK_ORDER.REQUEST, payload: { email, orderId } });

export const trackOrderSuccess = (payload) =>
  ({ type: TRACK_ORDER.SUCCESS, payload });

export const trackOrderFailure = (error) =>
  ({ type: TRACK_ORDER.FAILURE, payload: { error } });


// CLEAR TRACKING STATE
export const clearTracking = () =>
  ({ type: CLEAR_TRACKING });
